module.exports = __webpack_public_path__ + "b692ec4b5c747524f13153c3e405eae0.woff2";